module.exports = __webpack_public_path__ + "img/guinea.67dbad3.webp";